/* Spanish catalog mirroring locale-fr-part8.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'po.todaysPlanBase': 'Plan de hoy: el punto de partida',
  'po.editTodaysPlan': 'Editar el plan de hoy',
  'po.netWealthToday': 'Patrimonio neto hoy',
  'po.monthlySavingShort': 'Ahorro mensual',
  'po.extraDebtRepayment': 'Amortización extra de deuda',
  'po.return': 'Rentabilidad',
  'po.retirementAge': 'Edad de jubilación',
  'po.adjustAssumptions': 'Ajustar hipótesis',
  'po.lifeEvents': 'Eventos vitales',
  'po.lifeEventsSub': 'Planifica con antelación los grandes eventos (hijos, vivienda, excedencia, un año sabático) y comprueba cómo afectan al conjunto',
  'po.addEvent': 'Añadir evento',
  'po.lifeEventsHelp': 'Introduce eventos futuros con fecha de inicio, coste puntual, efecto mensual y duración. Cada evento activo se sitúa en el punto correcto de la previsión. Desactiva un evento para ver el plan sin él. Los eventos se guardan para el año seleccionado.',
  'po.effectOver5Years': 'Efecto a 5 años',
  'po.goalScore': 'Puntuación de objetivos',
  'po.goalScoreSub': 'Qué tan bien situado estás para alcanzar tus objetivos y qué mejora la puntuación',
  'po.whatAffectsGoalScore': 'Lo que influye en la puntuación de objetivos',
  'po.myRecommendationNow': 'Mi recomendación ahora mismo',
  'po.prioritise': 'Priorizar',
  'po.talkAboutPlan': 'Habla conmigo sobre el plan',
  'po.yourGoals': 'Tus objetivos',
  'po.yourGoalsSub': 'Cada objetivo con el importe restante, la fecha prevista y la probabilidad',
  'po.newGoal': 'Nuevo objetivo',
  'po.addGoal': 'Añadir objetivo',
  'po.editGoal': 'Editar objetivo',
  'po.deleteGoal': 'Eliminar objetivo',
  'po.remaining': 'Restante',
  'po.expectedDone': 'Finalización prevista',
  'po.probability': 'Probabilidad',
  'po.largestEffect': 'Mayor efecto',
  'po.howReachFaster': '¿Qué puedo hacer para lograrlo antes?',
  'po.nextMilestone': 'Próximo hito',
  'po.nextMilestoneSub': 'Lo que más probablemente lograrás primero, en orden cronológico',
  'po.yourLifePlan': 'Tu plan de vida',
  'po.yourLifePlanSub': 'Los hitos financieros más importantes que vienen, construidos a partir de tus objetivos y tu plan',
  'po.adjustLive': 'Ajusta las hipótesis: la previsión, los objetivos y las fechas se actualizan en directo mientras arrastras.',
  'po.deleteGoalTitle': '¿Eliminar el objetivo?',
  'po.deleteGoalConfirm': 'Eliminar el objetivo',
  'po.doYouWantToDelete': '¿Quieres eliminar',
  'po.ownPartnerSharedSub': 'Un resumen de tus gastos, los de tu pareja y los compartidos',
  'po.you': 'Tú',
  'po.partner': 'Pareja',
  'po.householdSpends': 'El hogar gasta',
  'po.reportSub': 'Consulta, compara, imprime y descarga informes mensuales y anuales',
  'po.print': 'Imprimir',
  'po.downloadPdf': 'Descargar PDF',
  'po.pdfBusy': 'Creando PDF …',
  'po.pdfFailed': 'No se pudo crear un PDF del informe. Inténtalo de nuevo o usa Imprimir.',
  'po.pdfFileName': 'informe-finanzas-personales',
  'po.compareWith': 'Comparar con',
  'po.compareHelp': 'Pon un periodo anterior al lado para ver el cambio. «Desactivado» muestra solo el periodo seleccionado.',
  'po.ongoingPeriod': 'Periodo en curso: las cifras son provisionales',
  'po.plummaSummary': 'Resumen de SuperPlumma',
  'po.wentWell': 'Esto ha ido bien',
  'po.canImprove': 'Esto se puede mejorar',
  'po.focusNextMonth': 'Prioridad el mes que viene:',
  'po.goDeeper': '¿Quieres profundizar? Pregúntame sobre el informe.',
  'po.plummaNoticed': 'SuperPlumma ha detectado',
  'po.savingsRate': 'Tasa de ahorro',
  'po.noImportedCosts': 'Sin gastos importados',
  'po.totalCosts': 'Gastos totales',
  'po.whatHappensNext': '¿Qué pasa después?',
  'po.setAsideOver12': 'Reservado en 12 meses',
  'po.averagePerMonth': 'Media por mes',
  'po.askWhatHappensNext': 'Pregúntame qué pasa después',
  'po.whatFiguresMean': 'Qué significan las cifras',
  'po.youHaveStated': 'Has indicado que',
  'po.howItLooksAhead': 'Cómo se ve de cara al futuro',
  'po.inSixMonths': 'En 6 meses',
  'po.inTwelveMonths': 'En 12 meses',
  'po.assetCategoryPh': 'Ej. Inmueble',
  'po.assetsAndWealth': 'Activos y patrimonio',
  'po.assetsAndWealthSub': 'Todo lo que posees: vivienda, vehículos, ahorros e inversiones',
  'po.assetsHelp': 'El valor total de lo que posees, tu deuda y el patrimonio neto (activos menos deuda). «Variación de valor esperada» resume cómo se espera que los activos suban o bajen de valor durante el año.',
  'po.totalAssets': 'Activos totales',
  'po.netWealth': 'Patrimonio neto',
  'po.expectedChangePerYear': 'Variación de valor esperada por año',
  'po.liquid': 'Líquido (ahorros y fondos)',
  'po.assetCount': 'Número de activos',
  'po.wealthHealth': 'Salud del patrimonio',
  'po.wealthHealthSub': 'Una valoración global de la solidez de tu patrimonio: diversificación, liquidez, riesgo y nivel de endeudamiento',
  'po.wealthStrongestOn': 'Tu patrimonio puntúa más alto en',
  'po.wealthDistribution': 'Cómo se reparte tu patrimonio entre categorías',
  'po.expectedDevelopment': 'Evolución esperada',
  'po.expectedDevelopmentSub': 'Basada en la variación de valor que has introducido para cada activo',
  'po.projectionHelp': 'La proyección usa la variación anual de valor esperada que has introducido para cada activo. Plumme todavía no incorpora datos de mercado externos para inmuebles, coches usados o fondos.',
  'po.withYourAssumptions': 'Con las hipótesis que has introducido, tu patrimonio cambia aproximadamente',
  'po.explainSimply': 'Explica la evolución de forma sencilla',
  'po.watchingClosely': 'Vigilando con especial atención',
  'po.watchingCloselySub': 'Los activos que se espera que pierdan valor o crezcan más despacio que la inflación',
  'po.explain': 'Explicar',
  'po.yourAssets': 'Tus activos',
  'po.yourAssetsSub': 'Toca un activo para editar su valor y sus detalles',
  'po.addAsset': 'Añadir activo',
  'po.askAboutTax': 'Pregúntame sobre el impuesto',
  'po.taxAssistant': 'Asistente de declaración de impuestos',
  'po.taxAssistantSub': 'SuperPlumma te guía paso a paso y adapta las preguntas sobre la marcha',
  'po.deductionHunter': 'Cazador de deducciones',
  'po.deductionHunterSub': 'Las deducciones están ordenadas por valor esperado: empieza por arriba, donde el beneficio es mayor',
  'po.whyIThinkThis': '¿Por qué lo pienso?',
  'po.dataIUsed': 'Datos que he usado',
  'po.whyYouQualify': 'Por qué cumples los requisitos para la deducción',
  'po.estimatedTaxBenefit': 'Beneficio fiscal estimado',
  'po.taxOptimisation': 'Optimización fiscal',
  'po.taxOptimisationSub': 'Medidas concretas ordenadas por plazo y lo que suponen para este año y el siguiente',
  'po.nextYearOnwards': 'El año que viene y después',
  'po.aiTaxCheck': 'Revisión fiscal con IA',
  'po.aiTaxCheckSub': 'SuperPlumma revisa tus datos fiscales importados',
  'po.readyToFile': 'Listo para revisión externa',
  'po.readyToFileSub': 'Compara la base con la declaración de impuestos y las cuentas anuales',
  'po.checkBasis': 'Base de la revisión',
  'po.requiresIntegration': 'Requiere una integración oficial, autenticación fuerte y aprobación explícita',
  'po.filingUnavailable': 'La presentación no está disponible',
  'po.whatIsMissing': '¿Qué falta antes de una revisión externa?',
  'po.whatRemains': 'Lo que queda',
  'po.taxBasisNotFetched': 'No se ha obtenido la base fiscal',
  'po.alreadyVerified': 'Ya revisado',
  'po.nothingVerified': 'Todavía no se ha revisado nada.',
  'spx.taxScheme': 'Régimen de impuestos y tasas',
  'spx.noItems': 'Todavía no hay elementos registrados.',
  'spx.removeSpec': 'Quitar especificación',
  'prd.import': 'Importar productos',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Exportar productos',
  'prd.csvName': 'CSV de productos',
  'prd.excelName': 'Excel de productos',
  'prd.countTemplateName': 'Plantilla de recuento de inventario',
  'prd.countTemplateEmpty': 'No hay mercancías que contar. La plantilla de recuento incluye los productos de tipo Mercancía.',
  'prd.countTemplateDone': 'Plantilla de recuento descargada. Rellena las cantidades a 31 de diciembre; el inventario se valora a coste de adquisición.',
  'prd.countTemplateError': 'No se pudo crear la plantilla de recuento.',
  'prd.colProductId': 'ID de producto',
  'prd.colInventoryAccount': 'Cuenta de inventario',
  'prd.colStockToday': 'Existencias hoy',
  'prd.colCountedQuantity': 'Cantidad contada',
  'prd.colTotalCostValue': 'Valor de coste total',
  'prd.colNote': 'Nota',
  'prd.countSheetTitle': 'Recuento de inventario',
  'prd.countSheetIntro': 'La cantidad y el coste unitario están rellenados de antemano a partir del registro de productos de hoy. Revísalos y corrígelos según el recuento real en la fecha de recuento.',
  'prd.countSheetDate': 'Fecha de recuento',
  'prd.countSheetCountedBy': 'Contado por',
  'prd.countSheetReference': 'Referencia',
  'prd.countSheetSignature': 'Firma',
  'prd.countSheetNoteLabel': 'Nota',
  'prd.countSheetNote': 'Esta lista documenta el recuento. El valor contable y el valor fiscal se determinan en el cierre del ejercicio.',
  'prd.countSheetInfoTab': 'Información',
  'prd.countSheetWrongTemplate': 'Usa la plantilla de recuento de Plumme. Las columnas no coinciden.',
  'prd.countSheetOnlyXlsx': 'La importación automática admite la plantilla de Excel (.xlsx). Los demás archivos se guardan como documentación.',
  'prd.countSheetTabNotFound': 'No se encontró la hoja {name}.',
  'prd.countSheetRowError': 'Fila {row}: revisa el artículo, la cuenta de inventario, la cantidad contada y el coste.',
  'prd.countSheetNoneCounted': 'No se encontraron cantidades rellenadas en la lista de recuento.',
  'prd.countSheetUnmappedAccount': 'La cuenta de inventario {account} no se puede asignar automáticamente. Revisa las cuentas en la revisión.',
  'prd.filterHelp': 'Filtra los productos por tipo (mercancía, servicio, alquiler), por si están en stock y por si se muestran los eliminados.',
  'prd.listTitle': 'Lista de productos',
  'prd.listSub': 'Las mercancías y servicios que vendes',
  'prd.new': 'Nuevo producto',
  'prd.searchPh': 'Buscar por nombre de producto, descripción, número de artículo o precio',
  'prd.searchHelp': 'Busca por nombre de producto, descripción, número de artículo o precio.',
  'prd.none': 'Todavía no hay productos aquí',
  'prd.listHelpTitle': 'La lista de productos',
  'prd.listHelp': 'Cada fila es un producto con su número de artículo, precio, tipo de IVA, tipo y existencias. Toca una fila para ver los detalles y editar.',
  'prd.detailsTitle': 'Detalles del producto',
  'prd.detailsHelp': 'Descripción, número de artículo, precio sin IVA, tipo de IVA, tipo y existencias del producto.',
  'prd.editHelp': 'Cambia el nombre, el precio, el IVA, el tipo y las existencias del producto.',
  'prd.delete': 'Eliminar producto',
  'prd.deleteHelp': 'Mueve el producto a eliminados. Podrás restaurarlo más tarde.',
  'prd.itemNo': 'N.º de artículo',
  'prd.colStockItem': 'Artículo',
  'prd.stockReasonDefault': 'Recuento físico',
  'prd.stock': 'Existencias',
  'prd.deleted': 'Eliminado',
  'prd.pickOwnColour': 'Elegir un color propio',
  'prd.namePh': 'Ej. Hora de consultoría',
  'prd.priceExVat': 'Precio sin IVA',
  'prd.price': 'Precio',
  'prd.priceIncVat': 'Precio con IVA',
  'prd.subscriptionPeriod': 'Periodo de suscripción',
  'prd.multiDayDiscount': 'Descuento por varios días',
  'prd.multiDayHelp': 'Solo se aplica a este producto de alquiler.',
  'prd.day2ChargedAt': 'El día 2 se cobra a',
  'prd.day3Onwards': 'Del día 3 en adelante',
  'prd.itemNumber': 'Número de artículo',
  'prd.accountFallbackName': 'Cuenta',
  'prd.acct3000': 'Ventas y retiros sujetos a IVA',
  'prd.acct3020': 'Ingresos por ventas de servicios, tipo de IVA alto',
  'prd.acct3030': 'Ingresos por ventas de mercancías, tipo de IVA medio',
  'prd.acct3050': 'Ingresos por ventas de mercancías, tipo de IVA bajo',
  'prd.acct3100': 'Ventas y retiros con IVA del 0 por ciento',
  'prd.acct3200': 'Ventas y retiros fuera del ámbito de la ley del IVA',
  'prd.acct3900': 'Otros ingresos de explotación',
  'prd.colProductName': 'Nombre del producto',
  'prd.colDescription': 'Descripción',
  'prd.colVat': 'IVA',
  'prd.colType': 'Tipo',
  'prd.colRentalDiscount': 'Descuento de alquiler',
  'prd.colSalesAccount': 'Cuenta de ventas',
  'prd.colEquivalentAccount': 'Equivalente a cuenta estándar',
  'prd.excelImportUnavailable': 'La importación de Excel todavía no está disponible.',
  'prd.excelExportUnavailable': 'La exportación a Excel todavía no está disponible.',
  'prd.colStatus': 'Estado',
  'prd.exportSheetName': 'Productos',
  'prd.typeHeading': 'Encabezado',
  'prd.typeTextLine': 'Línea de texto',
  'prd.textLinesTitle': 'Líneas de texto',
  'prd.newTextLine': 'Nueva línea de texto',
  'prd.updateTextLine': 'Actualizar línea de texto',
  'prd.saveTextLine': 'Guardar línea de texto',
  'prd.textLineNamePh': 'Ej. Texto de instalación estándar',
  'prd.textLineTextPh': 'Escribe el texto que se puede usar en las líneas de los documentos',
  'prd.styleFor': 'Estilo para {target}',
  'prd.styleTargetText': 'Texto',
  'prd.styleTargetName': 'Nombre',
  'prd.styleBold': 'Negrita',
  'prd.styleItalic': 'Cursiva',
  'prd.styleDivider': 'Separador',
  'prd.styleNoDivider': 'Sin separador',
  'prd.styleSummary': 'Nombre: {name} · Texto: {text} · {divider}',
  'prd.toastProductUpdated': 'Producto actualizado',
  'prd.toastProductSaved': 'Producto guardado',
  'prd.toastProductSaveError': 'No se pudo guardar el producto.',
  'prd.toastProductDeleted': 'Producto eliminado',
  'prd.toastProductDeleteError': 'No se pudo eliminar el producto.',
  'prd.toastTextLineUpdated': 'Línea de texto actualizada',
  'prd.toastTextLineSaved': 'Línea de texto guardada',
  'prd.toastTextLineSaveError': 'No se pudo guardar la línea de texto.',
  'prd.toastTextLineDeleted': 'Línea de texto eliminada',
  'prd.toastTextLineDeleteError': 'No se pudo eliminar la línea de texto.',
  'prd.toastImportNoneFound': 'No se encontraron productos en el archivo.',
  'prd.toastImportSuccess': '{count} productos importados',
  'prd.toastImportError': 'No se pudieron importar los productos.',
  'prd.toastExportNone': 'No hay productos que exportar',
  'prd.toastExportDone': 'Lista de productos descargada',
  'prd.toastExportError': 'No se pudo exportar la lista de productos.',
  'prd.textLineFilterHelp': 'Filtra las líneas de texto y los encabezados guardados.',
  'prd.filterOther': 'Otros',
  'prd.showDeleted': 'Mostrar eliminados',
  'prd.typeGoods': 'Mercancía',
  'prd.typeService': 'Servicio',
  'prd.typeRental': 'Alquiler',
  'prd.typeSubscription': 'Suscripción',
  'prd.stockOnly': 'Solo en stock',
  'prd.textLineSubtitle': 'Textos y encabezados guardados para documentos de venta',
  'prd.titleHelp': 'Tus productos: las mercancías y servicios que vendes, con precio, IVA y existencias. Toca un producto para ver los detalles.',
  'prd.uploadHelp': 'Importa productos desde un archivo.',
  'prd.downloadHelp': 'Descarga la lista de productos como CSV o Excel.',
  'prd.addHelp': 'Añade una nueva mercancía, servicio, suscripción o producto de alquiler.',
  'prd.textLineSearchPh': 'Buscar por nombre, texto o tipo',
  'prd.textLineSearchHelp': 'Busca líneas de texto y encabezados guardados.',
  'prd.emptyText': 'Añade las mercancías y servicios que vendes y facturar será rapidísimo.',
  'prd.textLineEmptyTitle': 'Todavía no hay líneas de texto',
  'prd.textLineEmptyText': 'Guarda textos recurrentes, encabezados y textos de producto sin precio.',
  'prd.colBalance': 'Saldo',
  'prd.colCostPerUnit': 'Coste por unidad',
  'prd.colTotalValue': 'Valor total',
  'prd.colStockAvailable': 'Existencias/disponible',
  'prd.noneShort': 'Ninguno',
  'prd.subscriptionLabel': 'Suscripción · {period}',
  'prd.month1Short': '1 mes',
  'prd.months12Short': '12 meses',
  'prd.copyToTextLine': 'Copiar a línea de texto',
  'prd.colProduct': 'Producto',
  'prd.colPrice': 'Precio',
  'prd.colName': 'Nombre',
  'prd.colStyle': 'Estilo',
  'prd.errNrTaken': 'El número de artículo «{nr}» ya está en uso.',
  'prd.errAccountCodeFormat': 'Usa una cuenta de ingresos que empiece por 3 y tenga 4 o 5 dígitos.',
  'prd.errAccountNameRequired': 'Ponle un nombre a la cuenta.',
  'prd.errAccountEquivalentRequired': 'Elige la cuenta estándar a la que debe corresponder esta.',
  'prd.errAccountExists': 'La cuenta {code} ya existe.',
  'prd.errCostPriceInvalid': 'El precio de coste debe ser un importe válido de al menos 0.',
  'prd.errTrackingDateRequired': 'Elige la fecha en la que debe empezar el seguimiento automático del inventario.',
  'prd.errStockNegative': 'Las existencias iniciales no pueden ser negativas.',
  'prd.errCostPriceRequired': 'Introduce un precio de coste para las existencias iniciales.',
  'prd.errCostPriceNegative': 'El precio de coste no puede ser negativo.',
  'prd.noName': 'Sin nombre',
  'prd.updateProduct': 'Actualizar producto',
  'prd.saveProduct': 'Guardar producto',
  'prd.rentalQtyLabel': 'Cantidad disponible para alquiler',
  'prd.autoInventoryTitle': 'Inventario y precio de coste automáticos',
  'prd.autoInventoryHelp': 'Las compras aumentan las existencias. Las ventas contabilizadas reducen las existencias y registran el precio de coste calculado por coste medio ponderado.',
  'prd.calculatedStock': 'Saldo de existencias calculado',
  'prd.openingStock': 'Existencias iniciales',
  'prd.avgCostPrice': 'Precio de coste medio',
  'prd.costPerUnit': 'Precio de coste por unidad',
  'prd.inventoryValueLine': 'Valor del inventario: {value}',
  'prd.month1': '1 mes',
  'prd.months12': '12 meses',
  'prd.advancedTitle': 'Datos avanzados del producto',
  'prd.advancedHelp': 'SKU, EAN/GTIN, grupo de productos y datos de importación.',
  'prd.noGroup': 'Sin grupo',
  'prd.removeGroup': 'Quitar grupo de productos',
  'prd.newGroupPh': 'Nuevo grupo de productos',
  'prd.brand': 'Marca',
  'prd.variantName': 'Nombre de la variante',
  'prd.supplierItemNumber': 'Número de artículo del proveedor',
  'prd.internalReference': 'Referencia interna',
  'prd.tags': 'Etiquetas',
  'prd.tagsPh': 'Ej. tienda online, repuesto, invierno',
  'prd.saveAsTextLineTitle': 'Guardar también como línea de texto',
  'prd.saveAsTextLineHelp': 'Crea una copia sin precio para las líneas de los documentos.',
  'prd.autoAccountLine': 'Automática: {account}',
  'prd.accountTypeLabel': 'Tipo de cuenta',
  'prd.selectAccount': 'Elegir cuenta',
  'prd.customAccountOption': 'Personalizada',
  'prd.accountInLedger': 'Cuenta en el libro mayor',
  'prd.accountNamePh': 'Facturación de partidas pasantes',
  'prd.equivalentForYearEnd': 'Equivalente para cuentas anuales/impuestos',
  'prd.selectStandardAccount': 'Elegir cuenta estándar',
  'sub.tabsHelp': 'Cambia entre suscripciones con facturación recurrente y listas de clientes para facturación o correo conjunto.',
  'sub.start': 'Inicio',
  'sub.end': 'Fin',
  'sub.endHelp': 'Déjalo vacío para continuar hasta que la suscripción se pause o se elimine.',
  'sub.internalComment': 'Comentario interno',
  'sub.saveCustomers': 'Guardar clientes',
  'sub.searchCustomers': 'Buscar clientes',
  'sub.searchCustomersPh': 'Buscar por nombre, correo o número de empresa...',
  'sub.selectVisible': 'Seleccionar visibles',
  'sub.deselectVisible': 'Deseleccionar visibles',
  'sub.noCustomers': 'Todavía no hay clientes',
  'sub.howToInvoice': '¿Cómo quieres facturar?',
  'sub.manualFlowNote': 'La opción de abajo inicia un flujo de factura manual para la suscripción.',
  'sub.sendInvoice': 'Enviar factura',
  'sub.openDraftFilled': 'Abre un borrador de factura con la suscripción ya rellenada.',
  'sub.openBlankDraft': 'Abre un borrador de factura en blanco con el grupo de clientes seleccionado.',
  'sub.subject': 'Asunto',
  'sub.message': 'Mensaje',
  'sub.removeAllAttachments': 'Quitar todos los adjuntos',
  'sub.addCustomers': 'Añadir clientes',
  'sub.noInvoiceSent': 'Ninguna factura enviada',
  'sub.noEmailSent': 'Ningún correo enviado',
  'sub.unknownCustomer': 'Cliente desconocido',
  'sub.customersCount': '{count} clientes',
  'sub.cpiAnnualSuffix': ' · IPC {rate} % anual',
  'sub.actionMenuLabel': 'Acción',
  'sub.nameRequiredSubscription': 'Ponle un nombre a la suscripción',
  'sub.nameRequiredList': 'Ponle un nombre a la lista',
  'sub.nameRequiredListError': 'Ponle un nombre a la lista.',
  'sub.nameRequiredAgreementError': 'Ponle un nombre al acuerdo.',
  'sub.editSubTitle': 'Editar suscripción',
  'sub.editListTitle': 'Editar lista',
  'sub.newSubTitle': 'Nueva suscripción',
  'sub.newListTitle': 'Nueva lista',
  'sub.saveChanges': 'Guardar cambios',
  'sub.saveSubscription': 'Guardar suscripción',
  'sub.saveList': 'Guardar lista',
  'sub.namePlaceholderSub': 'Ej. Membresía Oro',
  'sub.namePlaceholderList': 'Ej. Boletín',
  'sub.nextInvoiceDateLabel': 'Fecha de la próxima factura',
  'sub.cpiAdjustmentLabel': 'Ajuste por IPC',
  'sub.cpiAdjustmentHelp': 'Ajuste anual del precio de la suscripción según el índice de precios al consumo.',
  'sub.customerSavedToast': 'Cliente «{name}» guardado',
  'sub.saveCustomerError': 'No se pudo guardar el cliente.',
  'sub.addCustomersTitle': 'Añadir clientes · {name}',
  'sub.selectedCount': '{count} seleccionados',
  'sub.addAsNewCustomer': 'Añadir «{name}» como nuevo cliente',
  'sub.noContactInfo': 'Sin datos de contacto',
  'sub.addCustomersEmptyText': 'Añade primero clientes al registro de clientes, o escribe un nombre para crear uno nuevo.',
  'sub.sendInvoiceTitle': 'Enviar factura · {name}',
  'sub.attachmentTooLarge': 'Los adjuntos pueden ocupar como máximo {max}.',
  'sub.fillSubject': 'Rellena el asunto.',
  'sub.writeMessage': 'Escribe un mensaje.',
  'sub.sendEmailTitle': 'Enviar correo · {name}',
  'sub.sending': 'Enviando...',
  'sub.sendEmailButton': 'Enviar correo',
  'sub.readyCount': '{count} listos',
  'sub.attachmentsAddedCount': '{count} adjuntos añadidos',
  'sub.addAttachment': 'Añadir adjunto',
  'sub.emailSendNote': 'Los correos se envían a través del servidor. Puedes soltar archivos en cualquier parte del cuadro de diálogo o pegarlos con Ctrl+V. Los destinatarios sin dirección de correo se registran como no enviados.',
  'sub.typeSubscription': 'Suscripción',
  'sub.typeList': 'Lista',
  'sub.actionClose': 'Cerrar',
  'sub.actionOpen': 'Abrir',
  'sub.edit': 'Editar',
  'sub.emailLabel': 'Correo',
  'sub.resume': 'Reanudar',
  'sub.pause': 'Pausar',
  'sub.delete': 'Eliminar',
  'sub.tabCustomers': 'Clientes ({count})',
  'sub.tabInvoices': 'Facturas ({count})',
  'sub.tabEmails': 'Correos ({count})',
  'sub.addCustomersToInvoiceText': 'Añade clientes para facturarles.',
  'sub.removeMember': 'Quitar',
});
